


























































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Modal from '@/components/Modal.vue'
import { ChainModule } from '@/store/modules/chain.module'
import ScrollView from '@/components/ScrollView.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { EZuntaInvoiceType } from '@zunta/configurations'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  props: {
    batchId: {
      type: Number,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    ModalV2,
    Modal,
    ScrollView,
    Table
  }
})
export default class CommissionsHistoryModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)

  config: ITableConfig = {
    usePagination: false,
    useQuery: false,
    minHeight: 'calc(100vh - 320px)',
    maxHeight: 'calc(100vh - 320px)',
    fetchFunction: this.fetchCommissions,
    columns: [
      {
        minWidth: '200px',
        width: 20,
        key: 'chainFacility',
        searchKey: 'chainFacility',
        hasSort: true,
        hasSearch: true,
        label: 'Chain/Facility',
        type: ETableColumnType.default
      },
      {
        minWidth: '110px',
        width: 11,
        key: 'invoiceType',
        searchKey: 'invoiceType',
        hasSort: true,
        hasSearch: true,
        label: 'Invoice',
        type: ETableColumnType.select,
        options: [
          {
            key: EZuntaInvoiceType.CC,
            value: EZuntaInvoiceType.CC,
            content: 'Credit Card'
          },
          {
            key: EZuntaInvoiceType.ECHECK,
            value: EZuntaInvoiceType.ECHECK,
            content: 'eCheck'
          },
          {
            key: EZuntaInvoiceType.MONTHLY,
            value: EZuntaInvoiceType.MONTHLY,
            content: 'Monthly'
          },
          {
            key: EZuntaInvoiceType.MAILING,
            value: EZuntaInvoiceType.MAILING,
            content: 'Mailing'
          }
        ]
      },
      {
        class: 'text-center',
        minWidth: '100px',
        width: 12,
        key: 'gross',
        searchKey: 'gross',
        hasSort: true,
        hasSearch: true,
        label: 'Gross',
        type: ETableColumnType.default
      },
      {
        class: 'text-center',
        minWidth: '90px',
        width: 12,
        key: 'net',
        searchKey: 'net',
        hasSort: true,
        hasSearch: true,
        label: 'Net',
        type: ETableColumnType.default
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 10,
        key: 'rate',
        searchKey: 'rate',
        hasSort: true,
        hasSearch: true,
        label: 'Commission Rate',
        type: ETableColumnType.default
      },
      {
        minWidth: '200px',
        width: 20,
        key: 'dateRange',
        searchKey: 'dateRange',
        hasSort: true,
        hasSearch: true,
        label: 'Commission Date',
        type: ETableColumnType.dateRange
      },
      {
        class: 'text-right',
        minWidth: '100px',
        width: 15,
        key: 'amount',
        searchKey: 'amount',
        hasSort: true,
        hasSearch: true,
        label: 'Commission',
        type: ETableColumnType.default
      }
    ]
  }

  get commissions () {
    return this.$store.state.chain.usersCommissions
  }

  get commissionsTotal () {
    return this.$store.state.chain.usersCommissionsTotal
  }

  async fetchCommissions (filters: any) {
    const localFilters = {
      ...filters
    }
    delete localFilters.limit
    return this.chainModuleInstance.fetchCommissionsByFilters({
      ...localFilters,
      userId: this.$props.user.id,
      batchId: this.$props.batchId
    })
  }

  getInvoiceTypeLabel (type: EZuntaInvoiceType) {
    switch (type) {
      case EZuntaInvoiceType.CC:
        return 'Credit Card'
      case EZuntaInvoiceType.ECHECK:
        return 'eCheck'
      case EZuntaInvoiceType.MAILING:
        return 'Mailing'
      case EZuntaInvoiceType.MONTHLY:
        return 'Monthly'
      default:
        return 'Unknown Type'
    }
  }
}
